import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useContactInfoStore = defineStore('contactInfo', {
  state: () => ({
    contactInfo: null,
    loading: false,
    error: null,
    lastFetched: null
  }),
  getters: {
    needsRefresh: (state) => {
      // Refresh data if it's older than 15 minutes or if no data exists
      if (!state.lastFetched) return true
      const fifteenMinutesAgo = Date.now() - (15 * 60 * 1000)
      return state.lastFetched < fifteenMinutesAgo
    }
  },
  actions: {
    async fetchContactInfo(force = false) {
      // Don't fetch if already loading
      if (this.loading && !force) return
      
      // Don't fetch if data is fresh and not forcing
      if (!this.needsRefresh && !force && this.contactInfo) return
      
      this.loading = true
      this.error = null
      try {
        const data = await api.get('/contact-info')
        this.contactInfo = data
        this.lastFetched = Date.now()
      } catch (error) {
        this.error = error.message || 'Failed to fetch contact info'
        // Only clear data if we don't have any existing data
        if (!this.contactInfo) {
          this.contactInfo = null
        }
      } finally {
        this.loading = false
      }
    }
  }
}) 